export const tenderRejectionProtocolDictionaries = new Map<string, string>()
    .set("organisation", "kind")
    .set("classifier_dk", "dk021_uk")
    .set("units", "recommended")
    .set("tender_procurement_method_type", "tender_procurement_method_type");
